/* eslint-disable no-fallthrough */

const MILLISECONDS = {
  seconds: 1000,
  minutes: 60 * 1000,
  hours: 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
};


export default class Countdown {
  get endTime() {
    return this.$_endTime;
  }

  set endTime(value) {
    this.$_endTime = value;
  }

  get timeInterval() {
    if (this.$_intervalTime) {
      return this.$_intervalTime;
    }
    return MILLISECONDS[this.$_intervalString];
  }

  get timeLeft() {
    const out = this.endTime - Date.now();
    return out >= 0 ? out : 0;
  }

  get timeObj() {
    return {
      days: this.days,
      hours: this.hours,
      minutes: this.minutes,
      seconds: this.seconds,
      milliseconds: this.milliseconds,
    };
  }

  constructor({ endTime, interval = 'seconds', maxInterval = 'days' }) {
    if (!endTime) {
      throw new Error('Countdown: All things must come to an end.');
    }

    this.$_endTime = endTime;

    const intervalInMs = typeof interval === 'number';

    this.$_intervalString = !intervalInMs ? interval : null;
    this.$_intervalTime = intervalInMs ? interval : null;

    this.$_subscribers = [];
    this.maxInterval = maxInterval;

    this.days = 0;
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    this.milliseconds = 0;
  }

  update() {
    let modTime = this.timeLeft;

    if (!this.timeLeft) {
      console.log('Countdown, count over');
      this.stop();
      return;
    }

    switch (this.maxInterval) {
      case 'days': {
        this.days = Math.floor(modTime / MILLISECONDS.days);
        modTime %= MILLISECONDS.days;
      }

      case 'hours': {
        this.hours = Math.floor(modTime / MILLISECONDS.hours);
        modTime %= MILLISECONDS.hours;
      }

      case 'minutes': {
        this.minutes = Math.floor(modTime / MILLISECONDS.minutes);
        modTime %= MILLISECONDS.minutes;
      }

      case 'seconds': {
        this.seconds = Math.floor(modTime / MILLISECONDS.seconds);
        modTime %= MILLISECONDS.seconds;
      }

      default: {
        this.milliseconds = Math.floor(modTime);
      }
    }

    this.updateSubscribers();
  }

  updateSubscribers() {
    this.$_subscribers.forEach((fn) => {
      fn(this.timeObj);
    });
  }

  stop() {
    window.clearInterval(this.interval);
  }

  start() {
    this.update();
    this.interval = window.setInterval(this.update.bind(this), this.timeInterval);
  }

  destroy() {
    this.$_subscribers = [];
    this.stop();
  }

  subscribe(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Countdown: Invalid subscriber');
    }

    this.$_subscribers.push(fn);

    return this.unsubscribe.bind(this, fn);
  }

  unsubscribe(fn) {
    const subscribedIndex = this.$_subscribers.findIndex(fn);

    if (subscribedIndex) {
      this.$_subscribers.splice(subscribedIndex, 1);
    }
  }
}
